import { useTranslation } from 'react-i18next';

/**
 * Inline hint shown below a compare-mode widget when one or both
 * periods returned zero rows. Keeps users from staring at a flat
 * baseline wondering whether the dataset is broken (D-020 sparse-
 * data UX).
 */
type Props = {
  hasA: boolean;
  hasB: boolean;
  labelA: string;
  labelB: string;
};

export function CompareEmptyHint({
  hasA,
  hasB,
  labelA,
  labelB,
}: Props): JSX.Element | null {
  const { t } = useTranslation();
  if (hasA && hasB) return null;

  const message = !hasA && !hasB
    ? t('compare.noDataBoth')
    : !hasA
      ? t('compare.noDataA', { label: labelA })
      : t('compare.noDataB', { label: labelB });

  return (
    <div
      role="status"
      className="absolute bottom-1 left-2 right-2 px-2 py-1 rounded text-[11px] text-center pointer-events-none"
      style={{
        background: 'color-mix(in srgb, var(--color-warning) 18%, var(--color-bg))',
        color: 'var(--color-fg)',
        border: '1px solid color-mix(in srgb, var(--color-warning) 50%, transparent)',
      }}
    >
      {message}
    </div>
  );
}
